import { Navigate, Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { canSeeAny, firstAllowedPath } from "@/lib/menus";

// Wraps workspace-scoped pages. Super admin gets redirected to their panel.
// `menu` (string | string[]) = key permission menu yang dibutuhkan halaman ini.
export default function WorkspaceOnly({ children, menu }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "super_admin") return <Navigate to="/superadmin/users" replace/>;
  if (menu && !canSeeAny(user, Array.isArray(menu) ? menu : [menu])) {
    return (
      <div className="p-10 flex justify-center" data-testid="menu-forbidden">
        <div className="card-flat p-8 max-w-md text-center">
          <ShieldOff className="mx-auto text-rose-500" size={28}/>
          <div className="mt-3 font-semibold text-slate-900">Anda tidak memiliki akses ke menu ini</div>
          <div className="text-sm text-slate-500 mt-1">Hubungi Super Admin bila Anda membutuhkan akses.</div>
          <Link to={firstAllowedPath(user)} className="inline-block mt-4 text-sm brand-text hover:underline" data-testid="menu-forbidden-home">Ke halaman yang diizinkan</Link>
        </div>
      </div>
    );
  }
  return children;
}
